/* Shopify bundle option order is independent of the page's product order. */
function findFitVariant(bundle, primary, partner, position) {
  if (!primary || !partner || ![0, 1].includes(position)) return null;
  const options = position === 0 ? [primary.options[0], partner.options[0]] : [partner.options[0], primary.options[0]];
  return bundle.variants.find(v => v.options.length === 2 && v.options.every((value, i) => value === options[i])) || null;
}
if (typeof module !== 'undefined') module.exports = { findFitVariant };
if (typeof customElements !== 'undefined' && !customElements.get('complete-fit-choice')) {
  customElements.define('complete-fit-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.data = JSON.parse(this.querySelector('[data-fit-data]').textContent);
      const { primary, partner, bundle } = this.data;
      const optionNames = bundle.options.map(o => typeof o === 'string' ? o : o.name);
      this.position = this.dataset.primaryPosition ? Number(this.dataset.primaryPosition) - 1 : optionNames.indexOf(`${primary.title} (${primary.options[0]?.name || primary.options[0]})`);
      if (primary.options.length !== 1 || partner.options.length !== 1 || optionNames.length !== 2 || ![0, 1].includes(this.position)) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.form.fitChoice = this;
      this.addEventListener('change', () => this.update(), opts);
      this.form.querySelector('[name="id"]').addEventListener('change', () => this.update(), opts);
      this.checkout = this.form.querySelector('.product-form__checkout');
      if (this.checkout) { this.checkoutWasHidden = this.checkout.hidden; this.checkout.hidden = true; }
      this.hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.form?.fitChoice === this) delete this.form.fitChoice;
      if (this.checkout) this.checkout.hidden = this.checkoutWasHidden;
    }
    isFit() { return this.querySelector('input[value="fit"]').checked; }
    selected() {
      const primary = this.data.primary.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
      const partner = this.data.partner.variants.find(v => String(v.id) === this.querySelector('[data-partner-size]').value);
      return { primary, partner, bundle: findFitVariant(this.data.bundle, primary, partner, this.position) };
    }
    update() {
      const { primary, bundle } = this.selected();
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency || 'USD' }).format(cents / 100);
      this.querySelector('[data-single-price]').textContent = primary ? money(primary.price) : 'Unavailable';
      const primarySize = this.querySelector('[data-primary-size]');
      if (primarySize) primarySize.textContent = primary ? primary.options[0] : 'Choose above';
      const collapsed = !this.isFit() && this.dataset.expandDefault !== 'true';
      this.querySelector('[data-fit-body]').hidden = collapsed;
      this.querySelector('[data-fit-details]').hidden = collapsed;
      const selectionHint = this.querySelector('[data-fit-selection-hint]');
      if (selectionHint) selectionHint.hidden = this.isFit();
      this.querySelector('[data-full-price]').textContent = bundle ? money(bundle.price) : '';
      this.querySelector('[data-fit-price]').textContent = bundle ? money(Math.round(bundle.price * (100 - Number(this.dataset.discount)) / 100)) : '';
      this.querySelector('[data-fit-status]').textContent = bundle?.available ? `${this.dataset.discount}% off applied automatically in cart.` : 'This size combination is unavailable. Choose another size.';
      this.updateButtonLabel();
    }
    updateButtonLabel() {
      const button = this.form.querySelector('[name="add"]');
      const label = button?.querySelector('span');
      // Keep the theme's sold-out/unavailable text while the primary variant is disabled.
      if (!label || button.disabled) return;
      label.textContent = this.isFit() ? 'Add the Fit — Save ' + this.dataset.discount + '%' : 'Add to Cart';
    }
    applyTo(formData) {
      if (!this.isFit()) return;
      const { bundle } = this.selected();
      if (!bundle?.available) throw new Error('This fit is unavailable in the selected sizes. Choose another size or select the single product.');
      formData.set('id', String(bundle.id));
      formData.delete('selling_plan');
    }
  });
}
